import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { cloneDeep } from '@fi-shared/utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReportWidgetDetailsFilterTableBaseDirective } from '../../../shared/report-widget-details-filter-table-base.directive';
import {
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportHistorySummaryDetailsData,
} from '../../../shared/fi-checklist2-report';
import { FiChecklist2ReportHistoryService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-history.service';

@Component({
    selector: 'fi-history-checklists-summary-table-wrapper',
    templateUrl: './checklists-summary-table-wrapper.component.html',
    styleUrls: ['./checklists-summary-table-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-history-checklists-summary-table-wrapper' },
    standalone: false,
})
export class FiChecklist2ReportChecklistsSummaryTableWrapperComponent
    extends ReportWidgetDetailsFilterTableBaseDirective
    implements OnInit
{
    @Output() checklistsHistorySummaryChange = new EventEmitter<IChecklist2ReportChecklistSummary[]>();
    @Output() onShowChecklistHistoryDetails = new EventEmitter<IChecklist2ReportHistorySummaryDetailsData>();

    private _filteredChecklistsHistorySummary$ = new BehaviorSubject<IChecklist2ReportChecklistSummary[]>([]);
    get filteredChecklistsHistorySummary$(): Observable<IChecklist2ReportChecklistSummary[]> {
        return this._filteredChecklistsHistorySummary$.asObservable();
    }

    constructor(
        injector: Injector,
        private fiChecklist2ReportHistoryService: FiChecklist2ReportHistoryService,
    ) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setNewHistorySummaryData(this.reportData.getHistorySummary(this.reportParam.Id));

        this.fiChecklist2ReportDataService.subscribeOnDateRangeChanged(this.reportParam.Id, this.ngOnDestroy$, () => {
            this.loadNewHistorySummaryData();
        });
    }

    private setNewHistorySummaryData(historySummaryData: IChecklist2ReportChecklistSummary[]) {
        this._filteredChecklistsHistorySummary$.next(historySummaryData);
        this.checklistsHistorySummaryChange.emit(this._filteredChecklistsHistorySummary$.value);
    }

    selectedFilterItemsChanged() {
        this.onCurrentFilterChanged();
        this.loadNewHistorySummaryData();
    }

    private loadNewHistorySummaryData() {
        const dateRange = this.fiChecklist2ReportDataService.getDateRange(this.reportParam.Id);
        this.fiChecklist2ReportHistoryService
            .getChecklistHistorySummary(this.currentFilter, dateRange, this.reportData.auditMode)
            .then((data) => this.setNewHistorySummaryData(data));
    }

    showChecklistHistoryDetails(checklistSummary: IChecklist2ReportChecklistSummary) {
        this.onShowChecklistHistoryDetails.emit({
            checklistSummary,
            filter: cloneDeep(this.currentFilter),
        });
    }
}
